import React,{ useState } from "react";
import Draggable from "react-draggable";
import StaffCallNetwork from "../popups/StaffCallNetwork";
import telIcon from "../../img/icon/callBtn.svg";

const FlyCalling = () => {

  const [varOpenCallNetwork,setOpenCallNetwork] = useState(false);
  const onCallingListHandler = (e) => {
    setOpenCallNetwork(true);
  }

  return (
    <>
      <Draggable cancel=".fly-button">
        <div className="fly-button" onClick={e=>onCallingListHandler(e)}>
          <img src={telIcon} alt=""/>
        </div>
      </Draggable>
      <StaffCallNetwork varOpenCallNetwork={varOpenCallNetwork} setOpenCallNetwork={setOpenCallNetwork}/>
    </>
  );
}
export default FlyCalling;